<template>
  <v-container fluid class="background-color-white pa-0">
    <v-row align="center" class="background-color-white" no-gutters>
      <v-col cols="3" class="text-right">
        <a
          class="align-center background-color-seashell d-inline-flex font-size-sm nav-button-border-radius pl-1 pr-3"
          @click="$router.go(backCount)"
        >
          <v-icon color="primary" class>mdi-chevron-left</v-icon>
          Back
        </a>
      </v-col>
      <v-col cols="6" class="font-size-lg font-weight-semibold text-center pt-4"
      >My Cart
      </v-col
      >
      <v-col cols="3"></v-col>
    </v-row>
    <Cart class="padding-bottom-leaves-space-for-checkout-button" />
  </v-container>
</template>

<script>
import Cart from "@/components/Cart/Cart.vue";

export default {
  name: "CartView",
  components: { Cart },
  data() {
    return {
      backCount: -1
    };
  },
  beforeRouteEnter(to, from, next) {
    let backCount;
    switch (from.name) {
      case "sms":
        backCount = -4;
        break;
      case "email":
        backCount = -3;
        break;
      default:
        backCount = -1;
        break;
    }
    next((vm) => {
      vm.backCount = backCount;
    });
  }
};
</script>
<style scoped>
.padding-bottom-leaves-space-for-checkout-button {
  padding-bottom: 100px;
}
</style>
